export interface ProfileCompletionStep {
  labelKey: string;
  completed: boolean;
}

export function isPersonalDataComplete(
  user: Record<string, unknown> | null | undefined,
): boolean {
  if (!user) {
    return false;
  }
  return !!(user['name'] && user['lastName'] && user['birthday']);
}

export function isPhoneVerified(
  user: Record<string, unknown> | null | undefined,
): boolean {
  return !!user?.['isPhoneVerified'];
}

export function isEmailVerified(
  user: Record<string, unknown> | null | undefined,
): boolean {
  return !!user?.['active'];
}

/** Home banner order (Figma). Same four steps as profile-new. */
export function getProfileCompletionSteps(
  user: Record<string, unknown> | null | undefined,
): ProfileCompletionStep[] {
  return [
    { labelKey: 'PROFILE_PAGE.STEP_REGISTER', completed: true },
    {
      labelKey: 'PROFILE_PAGE.STEP_EMAIL',
      completed: isEmailVerified(user),
    },
    {
      labelKey: 'PROFILE_PAGE.STEP_PERSONAL',
      completed: isPersonalDataComplete(user),
    },
    {
      labelKey: 'PROFILE_PAGE.STEP_PHONE',
      completed: isPhoneVerified(user),
    },
  ];
}

export function getProfileCompletionPercentage(
  user: Record<string, unknown> | null | undefined,
): number {
  const steps = getProfileCompletionSteps(user);
  const done = steps.filter((step) => step.completed).length;
  return Math.round((done / steps.length) * 100);
}

export function isProfileComplete(
  user: Record<string, unknown> | null | undefined,
): boolean {
  return getProfileCompletionPercentage(user) >= 100;
}
